import { SIMPLMenuHeader } from "../../components/comons/header/SIMPLMenuHeader";
import { SIMPLTable } from "../../components/comons/table/SimplTable";
import { Layout } from "../../components/comons/layout/Layout";
import { LABELS } from "~/resources/Labels";
import { SIMPLTitle } from "../../components/comons/title/SIMPLTitle";
import { ChangeEvent, useEffect, useState } from "react";
import { FormCloudEnviroment, FormCloudEnvironmentResponse, PropRow, SortTable } from "~/models/Comons";

import AddIcon from "@mui/icons-material/Add";
import { Entries } from "~/models/enums/Entries";
import {
  attachResourcesToCloudEnviroments,
  displayEntries,
  sortScripts,
} from "~/Utils/Utils";
import { SIMPLButtonCustomized } from "../../components/comons/button/SIMPLButtonCustumized";
import { SIMPLAlert } from "../../components/comons/dialog/SimplAlert";
import { MESSAGES } from "~/resources/Message";
import { toast } from "react-toastify";
import { PayloadType } from "~/models/types/Payload";
import { buildLogoutUrl } from "~/services/keycloak";
import useSessionTimeout from "~/services/session/SessionTimeOut";
import { AddProvider } from "./AddProvider";
import { CloudEnviromentHeader } from "~/models/cloudenviroment/CloudEnviromentHeader";
import { useAppDispatch } from "~/hooks/appSelector";
import { useDeleteCloudEnviromentsMutation, useGetCloudEnviromentsQuery } from "~/services/cloudenviroment";
import { DetailViewCloudEnviroment } from "./DetailsViewCloudEnviroment";
import { DELETE_CLOUDENVIROMENT_BYID } from "~/store/feature/CloudEnviroment";
import { EditCloudEnviroment } from "./EditCloudEnviroment";

export const SIMPLCloudEnvironment = () => {
   const dispatch = useAppDispatch();
  const [deleteScript] = useDeleteCloudEnviromentsMutation();
  const [active] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [isAddModalOpenCloudEnviroment, setIsAddModalOpenCloudEnviroment] =
    useState(false);
  const [rows, setRows] = useState([] as PropRow[]);
  const [size, setSize] = useState<number>(5);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [showPagination, setShowPagination] = useState(true);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [openDetailView, setOpenDetailView] = useState(false);
  const [openEditView, setOpenEditView] = useState(false);
  const [item, setItem] = useState({} as FormCloudEnviroment);
   const [editItem, setEditItem] = useState({} as FormCloudEnvironmentResponse);
  const [deleteModal, setDeleteModal] = useState(false);
  const INACTIVITY_LIMIT = Number(import.meta.env.VITE_INACTIVITY_LIMIT);
  const FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN = Number(
    import.meta.env.VITE_FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN
  );
   const { data,refetch} = useGetCloudEnviromentsQuery({ page, size,active });
  const [sortConfig, setSortConfig] = useState<SortTable>({
    key: "",
    direction: LABELS.ASC,
  });
  const handleSort = (key: string) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === LABELS.ASC
        ? LABELS.Desc
        : LABELS.ASC;
    setSortConfig({ key, direction });
  };

  /**
   * Initializes session timeout handling.
   *
   * @param {Object} config - Configuration for session timeout.
   * @param {number} config.inactivityLimit - Time in ms before user is considered inactive.
   * @param {number} config.forcedLogoutLimit - Time in ms before forced logout after inactivity.
   * @param {Function} config.buildLogoutUrl - Function that returns the logout URL.
   * @param {Storage} config.storage - Storage mechanism (e.g., sessionStorage).
   * */
  useSessionTimeout({
    inactivityLimit: INACTIVITY_LIMIT,
    forcedLogoutLimit: FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN,
    buildLogoutUrl,
    storage: sessionStorage,
  });

  /**
   * Initializes and sets the table rows by:
   * 1. Filtering scripts based on the active tab.
   * 2. Sorting the filtered scripts according to the sort configuration.
   * 3. Mapping sorted scripts to table row format and setting rows.
   */
  const initCloudEnviroment = () => {
    // Ensure payload exists before processing
        const payload = data?.payload as PayloadType | undefined;
      
        if (!payload || payload.length === 0) {
          setShowPagination(false);
          return; 
        }
        // Attach resources, sort scripts, and customize entries
        const scriptMergedList = attachResourcesToCloudEnviroments(payload);
        const sortedScripts = sortScripts(scriptMergedList, sortConfig);
        const customizedList = displayEntries(sortedScripts, totalElements, Entries.Twenty);
        // Set pagination visibility and total elements count
        const totalPages = payload?.page?.totalPages ?? 0;
        setTotal(Number(totalPages));
      
        if (payload?.page?.totalElements) {
          setTotalElements(payload?.page?.totalElements);
          
        }
      
        // Process rows and set them
        const scriptRows: PropRow[] = customizedList.map((scriptItem: any) => ({
          row: scriptItem,
        }));
    
        setRows(scriptRows);
        setShowPagination(true); 
      }

  useEffect(() => {
    initCloudEnviroment();
  }, [data, active, sortConfig, size, total, totalElements]);

  /**
   * @effect
   * - Runs when the 'active' dependency changes.
   * - Calls setPage(1) to reset the pagination.
   */
  useEffect(() => {
    setPage(0);
    handlePaginationSize();
  }, [active, size]);
  const handleCloseAddModal = () => setIsAddModalOpen(false);
  const handlePaginationSize = () => {
    if ([Entries.Ten, Entries.Twenty].includes(size)) {
      setPage(0);
    }
  };
  /* Renders "Close" and "Start" buttons for alerts */
  const renderCloudEnviromentButtons = () => (
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Close"
          secondary
          buttonHandlerAction={() => setIsAddModalOpenCloudEnviroment(false)}
        />
      </div>
  
  );
 /* Renders "Cancel" and "Delete Item" buttons for alerts */
  const renderAlertButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={() => setDeleteModal(false)}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized
          label="Delete Item"
          danger
          buttonHandlerAction={handleDeleteItem}
        />
      </div>
    </>
  );
  
/*Renders delete alert with cancel and delete actions */
  const renderDeleteAlert = () =>
    deleteModal && (
      <SIMPLAlert
        onCancel={() => setDeleteModal(false)}
        message={MESSAGES.MessageDialogDelete(item.environmentName!)}
        title="Delete Cloud Environment "
        actions={renderAlertButtons()}
      />
    );

 

  const handleConfirmDelete = (scriptItem:FormCloudEnviroment) => {
    if (scriptItem.id) {
      setItem(scriptItem);
      setDeleteModal(true);
    } else {
      console.warn(LABELS.ScriptIdDonotExist);
    }
  };

const handleDeleteItem = async () => {
  try {
    setDeleteModal(false); // Close modal immediately
    toast.loading('Deleting Script...');

    const response = await deleteScript(item.id!).unwrap();

    // Only throw if response exists and says it's a failure
    if (response && response.success === false) {
      throw new Error(MESSAGES.ErrorDelectingScript);
    }

    dispatch(DELETE_CLOUDENVIROMENT_BYID(item.id!));

    toast.dismiss();
    toast.success(MESSAGES.MessageSucessFullyRemoved);
  } catch (error) {
    toast.dismiss();
    console.error(MESSAGES.ErrorDelectingScript, error);
    toast.error(MESSAGES.ErrorDelectingScript);
  } finally {
    refetch();
  }
};


  const renderDetailViewScript = () =>
    openDetailView && (
      <DetailViewCloudEnviroment item={editItem} onClose={() => setOpenDetailView(false)} />
    );
     const renderEditView = () =>
    openEditView && (
      <EditCloudEnviroment
        onCloseModal={()=>setOpenEditView(false)}
        title='Update Cloud Environment '
        editedItem={item}
        setConfig={setSortConfig}
        refetch={refetch} />
    );
  /*Renders decommission alert with close and start actions */
  const renderCloudEviromentAlert = () =>
    isAddModalOpenCloudEnviroment && (
      <SIMPLAlert
        onCancel={() => setIsAddModalOpenCloudEnviroment(false)}
        title={LABELS.TitleDecommission}
        actions={renderCloudEnviromentButtons()}
        message={""}
      >
        <p>{MESSAGES.MessageDecommission}</p>
      </SIMPLAlert>
    );
  const showFilterHandler = () => setShowFilter((prev) => !prev);

  const handleSizeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSize(Number(e.target.value));
  };
  const handleResetAll = () => {
    setPage(0);
    setShowFilter(false);
  };
  const handlePageChange = (page: number) => {
    setPage(page);
  };
  /* Renders the "Add Script" button */
  const renderButtonAddProvider = () => (
    <SIMPLButtonCustomized
      label={LABELS.AddCloud}
      buttonHandlerAction={() => setIsAddModalOpen(true)}
      firstIcon={<AddIcon fontSize="small" />}
      secondIcon={<AddIcon fontSize="small" />}
      secondary
    />
  );
  const renderAddProviderModal = () =>
    isAddModalOpen && (
      <AddProvider
        onCloseModal={handleCloseAddModal}
        editedItem={null}
        setConfig={setSortConfig}
        title={LABELS.AddCloudEnviroment}
        refetch={refetch}
      />
    );
  const renderSIMPLTable = () => (
    <div className="flex flex-col w-full">
      <div className="mt-5">
        <div className="container mx-auto mt-10">
          <SIMPLTable
            clear={handleResetAll}
            button={renderButtonAddProvider()}
            page={page}
            total={total}
            totalElements={totalElements}
            showPagination={showPagination}
            active={true}
            showHandler={showFilterHandler}
            filterActive={showFilter}
            tableHeaders={CloudEnviromentHeader}
            rows={rows}
            onChangePage={handlePageChange}
            onChange={handleSizeChange}
            handleOpenDetail={handleOpenDetail}
            handleOpenEdit={handleEdit}
            handleRowClick={handleRowClick}
            handleDelete={handleConfirmDelete}
            sortConfig={sortConfig}
            handleSort={handleSort}
            chipLabels={[]}
            showButtonDecommission
              showButtonDetails
              showEdit
              showButtonDelete
          />
        </div>
      </div>
    </div>
  );
  const renderSIMPLTitle = () => (
    <SIMPLTitle title={LABELS.CloudEnviromentManagment} />
  );
  const handleRowClick = (scriptItem: FormCloudEnvironmentResponse) => {
      if (!scriptItem.id) {
        setEditItem(scriptItem);
        setOpenDetailView(true);
      }
    };
  
    const handleOpenDetail = (scriptItem: FormCloudEnvironmentResponse) => {
      if (scriptItem.id) {
        setEditItem(scriptItem);
        setOpenDetailView(true);
      } else {
        console.warn(LABELS.ScriptIdDonotExist);
      }
    };
    const handleEdit = (scriptItem: FormCloudEnviroment) => {
      if (scriptItem.id) {
        setItem(scriptItem);
        setOpenEditView(true);
      } else {
        console.warn(LABELS.ScriptIdDonotExist);
      }
    };
  return (
    <SIMPLMenuHeader>
      <Layout>
        {renderSIMPLTitle()}
        {renderSIMPLTable()}
        {renderDetailViewScript()}
        {renderEditView()}
        {renderDeleteAlert()}
        {renderAddProviderModal()}
        {renderCloudEviromentAlert()}
      </Layout>
    </SIMPLMenuHeader>
  );
};
